import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../../layouts/dashboard';
import { NotificationEdit } from '../../../components/Notifications/NotificationsEdit';

export const NotificationEditPage = () => {
  return (
    <DashboardLayout title={'Notificaciónes'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <NotificationEdit />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
